import { ChangeEvent, FC, Ref, forwardRef, useState } from 'react'
import { Container, Error, InputContainer, StyledInput, StyledLabel } from './styled'

type Props = {
  error?: string
  getValues: (field: string) => string
  placeholder?: string
  onChange?: (event: ChangeEvent) => void
  ref?: Ref<HTMLInputElement>
  name: string
}

export const Input: FC<Props> = forwardRef<HTMLInputElement, Props>((props, ref) => {
  const { error, getValues, placeholder, onChange, name } = props
  const [focused, setFocused] = useState(false)
  const [isEmpty, setIsEmpty] = useState(true)

  const handleBlur = () => {
    setFocused(false)
    setIsEmpty(!getValues(name))
  }

  const handleFocus = () => {
    setFocused(true)
  }

  return (
    <Container>
      <InputContainer error={error} focus={focused}>
        <StyledInput
          error={error}
          onBlur={handleBlur}
          onChange={onChange}
          name={name}
          onFocus={handleFocus}
          ref={ref}
          placeholder={placeholder}
        />
        <StyledLabel empty={isEmpty} error={error} focus={focused} htmlFor={name}>
          {placeholder}
        </StyledLabel>
      </InputContainer>
      {error && <Error>{error}</Error>}
    </Container>
  )
})
